import { ElasticTournament, TournamentRoundStatusEnum } from '@spikemark/rest-api';

export function getRoundStatus(
  tournament: Pick<ElasticTournament, 'roundStatuses'>,
  roundId: number
): TournamentRoundStatusEnum {
  return (
    tournament.roundStatuses?.find((round) => round.roundId === String(roundId))?.status ?? 'ACTIVE'
  );
}
